import { Id, PolicyConferenceRules } from 'src/types'

type GetDefaultValuesProps = {
  organization_id: Id
  policy_conference_id: Id
}

export function getDefaultValues({
  organization_id,
  policy_conference_id
}: GetDefaultValuesProps): PolicyConferenceRules {
  return {
    active: true,
    code: '',
    include_original_checkers: false,
    name: '',
    organization_id,
    policy_conference_exception_trees: [],
    policy_conference_id,
    policy_conference_rule_id: `${new Date().toLocaleString()}`,
    policy_receipt_rule_id: ''
  }
}

export const initialValues = {} as PolicyConferenceRules
